import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import useUrlState from "@ahooksjs/use-url-state";
import tasksAPI from "../../../../services/tasks";
import scheduleAPI from "../../../../services/schedule";
import classesAPI from "../../../../services/classes";
import coursesAPI from "../../../../services/courses";
import slotsAPI from "../../../../services/slots";
import teachersAPI from "../../../../services/teachers";
import classroomsAPI from "../../../../services/classrooms";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import { Dropdown } from "primereact/dropdown";
import UpdateScheduleModal from "./UpdateScheduleModal";
import { SelectButton } from "primereact/selectbutton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CLASSROOMS, PERMISSION_TRAINING_COURSES, PERMISSION_TRAINING_SCHEDULE, PERMISSION_TRAINING_SLOTS, PERMISSION_TRAINING_TASKS, PERMISSION_TRAINING_TEACHERS } from "../../../../permissions";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaTeacherAvatar from "../../components/MeaTeacherAvatar";
import { useMediaQuery } from "react-responsive";


const ScheduleListComponent = forwardRef((props, ref) => {
  const {
    selectedFields,
    filter,
    showFilterButton,
    showToolbar,
    showAddButton,
    showTotalSelectedElements,
    schoolId,
    trainingId,
    showPaginator = true,
    pageSize: initialPageSize = 30,
    disableNavigation = false,
    mobileCards = false,
  } = props;
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  //
  const { hasPermission } = useAuthContext();
  const accessToken = "";
  //
  //
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  //
  const tableRef = useRef();
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  const toast = useRef();
  //
  let selectedData = {
    selection: selectedFields?.selection ?? true,
    slot: selectedFields?.slot ?? true,
    startHour: selectedFields?.startHour ?? true,
    endHour: selectedFields?.endHour ?? true,
    classe: selectedFields?.classe ?? true,
    course: selectedFields?.course ?? true,
    teacher: selectedFields?.teacher ?? true,
    classroom: selectedFields?.classroom ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  //
  const [state, setState] = useUrlState({
    schedulePage: "1",
    scheduleFilter: JSON.stringify({
      slot_id: filter?.slot_id || "",
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      course_id: filter?.course_id || "",
      teacher_id: filter?.teacher_id || "",
      classroom_id: filter?.classroom_id || "",
    }),
  });
  //
  const queryList = scheduleAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.scheduleFilter)
  );
  const [schedule, setschedule] = useState(null);
  //
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const coursesQuery = coursesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const slotsQuery = slotsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const teachersQuery = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classroomsQuery = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  //
  const setFilter = (field, value) => {
    let currentFilter = state?.scheduleFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      schedulePage: 1,
      scheduleFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.scheduleFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };
  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <div>
          <MeaButton
            label="Programmer une séance"
            disabled={true}
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouvelle session"
            permission={PERMISSION_TRAINING_SCHEDULE.CREATE}
          />
          <MeaButton
            label="Générer le programme de la semaine"
            icon="pi pi-sun"
            size="small"
            className="p-button mr-2 action"
            outlined
            onClick={() => {
              confirmDialog({
                message:
                  "Voulez-vous générer le programme de la semaine pour cette formation?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                acceptLabel: "Oui",
                rejectLabel: "Non",
                defaultFocus: "reject",
                accept: () => {
                  tasksAPI
                    .GenerateSchedule(schoolId, trainingId, accessToken)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: "Succès",
                        life: 3000,
                      });
                      queryList?.refetch();
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de génération!",
                      });
                    });
                },
              });
            }}
            data-pr-tooltip="Generate"
            permission={PERMISSION_TRAINING_TASKS.GENERATE_SCHEDULE_ENTRIES}
          />
        </div>
      )}
    </div>
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
    getSelectedElements: () => {
      return tableRef.current.getSelectedElements();
    },
  }));
  //
  if (mobileCards && isMobile) {
    const items = queryList?.data?.data || [];
    if (queryList?.isLoading) {
      return <div className="py-4 text-center text-500">Chargement...</div>;
    }
    if (queryList?.isError) {
      return <div className="py-2 text-center text-red-500">Impossible de récupérer le programme.</div>;
    }
    if (items.length === 0) {
      return <div className="py-3 text-center text-500">Aucune séance programmée.</div>;
    }
    return (
      <div className="flex flex-column gap-2" data-testid="schedule-cards">
        {items.map((item) => (
          <div
            key={item.id}
            className="border-1 surface-border border-round p-3 flex flex-column gap-2"
            data-testid={`schedule-card-${item.id}`}
          >
            <div className="flex justify-content-between align-items-start gap-2">
              <span className="font-semibold text-900">{item?.course?.name || "-"}</span>
              {selectedData.classe && item?.classe?.name && <small className="text-600">{item.classe.name}</small>}
            </div>
            <div className="flex flex-wrap align-items-center gap-3 text-sm text-700">
              {selectedData.slot && item?.slot?.name && (
                <span>
                  <i className="pi pi-calendar text-xs mr-1" />
                  {item.slot.name}
                </span>
              )}
              {(item?.start_hour || item?.end_hour) && (
                <span>
                  <i className="pi pi-clock text-xs mr-1" />
                  {[item?.start_hour, item?.end_hour].filter(Boolean).join(" – ")}
                </span>
              )}
              {selectedData.classroom && item?.classroom?.name && (
                <span>
                  <i className="pi pi-map-marker text-xs mr-1" />
                  {item.classroom.name}
                </span>
              )}
            </div>
            {selectedData.teacher && item?.teacher && (
              <MeaTeacherAvatar
                teacher={item.teacher}
                permission={PERMISSION_TRAINING_TEACHERS.GET}
                schoolId={schoolId}
                trainingId={trainingId}
                noNavigation={disableNavigation}
              />
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <ConfirmDialog />
      <Toast ref={toast} position="bottom-center" />
      <MeaDataTable
        ref={tableRef}
        query={queryList}
        serviceAPI={scheduleAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        accessToken={accessToken}
        names={{
          pagination: "schedule",
          singular: "séance",
          plural: "séances par semaine",
        }}
        startToolbarTemplate={startToolbarTemplate}
        showToolbar={showToolbar}
        showFilter={false}
        showFilterButton={showFilterButton}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_SCHEDULE.DELETE)}
        showTotalSelectedElements={showTotalSelectedElements}
        setPage={setPage}
        setPageSize={setPageSize}
        paginator={showPaginator}
        showSelection={selectedData.selection}
        pageSize={50}
      >
        {selectedData.selection && (
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
        )}
        {selectedData.classe && (
          <Column
            field="classe?.name"
            header="Classe"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classes/" +
                  schedule?.classe?.id
                }
                permission={PERMISSION_TRAINING_CLASSES.GET}
                noNavigation={disableNavigation}
              >
                {schedule?.classe?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classesQuery, "classe_id")
            }
          ></Column>
        )}

        {selectedData.course && (
          <Column
            field="schedule_item.course.name"
            header="Matière"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/courses/" +
                  schedule?.course?.id
                }
                permission={PERMISSION_TRAINING_COURSES.GET}
                noNavigation={disableNavigation}
              >
                {schedule?.course?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, coursesQuery, "course_id")
            }
          ></Column>
        )}

        {selectedData.slot && (
          <Column
            header="Créneau"
            body={(schedule) => {
              return (
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/slots/" +
                    schedule?.slot_id
                  }
                  permission={PERMISSION_TRAINING_SLOTS.GET}
                  noNavigation={disableNavigation}
                >
                  {schedule?.slot?.name}
                </MeaLink>
              );
            }}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, slotsQuery, "slot_id")
            }
          ></Column>
        )}
        {selectedData.startHour && (
          <Column header="Heure de début" field="start_hour"></Column>
        )}
        {selectedData.endHour && (
          <Column header="Heure de fin" field="end_hour"></Column>
        )}
        {selectedData.teacher && (
          <Column
            header="Enseignant(e)"
            body={(schedule) => (
              <MeaTeacherAvatar
                teacher={schedule?.teacher}
                permission={PERMISSION_TRAINING_TEACHERS.GET}
                schoolId={schoolId}
                trainingId={trainingId}
                noNavigation={disableNavigation}
              />
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) => {
              return (
                <Dropdown
                  value={JSON.parse(state.scheduleFilter)["teacher_id"] || ""}
                  options={teachersQuery?.data?.data?.map((item) => {
                    return {
                      label:
                        item.member?.name ||
                        item.member?.lastname + " " + item.member?.firstname,
                      value: item.id,
                    };
                  })}
                  onChange={(e) => {
                    options.filterApplyCallback(e.value);
                    setFilter("teacher_id", e.value || "");
                  }}
                  //itemTemplate={statusItemTemplate}
                  placeholder="Séléctionner"
                  className="p-column-filter"
                  showClear
                />
              );
            }}
          ></Column>
        )}
        {selectedData.classroom && (
          <Column
            field="classroom.name"
            header="Salle"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classrooms/" +
                  schedule?.classroom?.id
                }
                permission={PERMISSION_TRAINING_CLASSROOMS.GET}
                noNavigation={disableNavigation}
              >
                {schedule?.classroom?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classroomsQuery, "classroom_id")
            }
          ></Column>
        )}
        {selectedData.edit && (
          <Column
            body={(schedule) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setschedule(schedule);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_SCHEDULE.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateScheduleModal ref={updateModalRef} schedule={schedule} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
    </>
  );
});

export default ScheduleListComponent;
